__turbopack_context__.v({
  "root": "paper-module__-mjr7q__root",
});
